import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  HomeIcon,
  DocumentTextIcon,
  UserGroupIcon,
  UserIcon,
  ClipboardIcon,
  ChartBarIcon,
  CreditCardIcon,
  CogIcon,
  QuestionMarkCircleIcon
} from '@heroicons/react/24/outline';

interface NavItem {
  name: string;
  path: string;
  icon: React.ComponentType<any>;
}

const navItems: NavItem[] = [
  { name: 'Dashboard Overview', path: '/admin/dashboard', icon: HomeIcon },
  { name: 'Task Templates', path: '/admin/templates', icon: DocumentTextIcon },
  { name: 'Candidates', path: '/admin/candidates', icon: UserGroupIcon },
  { name: 'Interviewers', path: '/admin/interviewers', icon: UserIcon },
  { name: 'Active Tasks', path: '/admin/tasks', icon: ClipboardIcon },
  { name: 'Analytics', path: '/admin/analytics', icon: ChartBarIcon },
  { name: 'Subscription & Billing', path: '/admin/subscription', icon: CreditCardIcon },
  { name: 'Settings', path: '/admin/settings', icon: CogIcon },
  { name: 'Support', path: '/admin/support', icon: QuestionMarkCircleIcon }
];

const OrgAdminSidebar: React.FC = () => {
  const location = useLocation();

  return (
    <div className="w-64 bg-white shadow-lg h-screen fixed left-0 top-0 overflow-y-auto">
      <div className="p-4">
        <h2 className="text-xl font-bold text-gray-800 mb-8">Organization Admin</h2>
        <nav>
          <ul className="space-y-2">
            {navItems.map((item) => {
              const isActive = location.pathname === item.path;
              const Icon = item.icon;
              
              return (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className={`flex items-center p-3 rounded-lg transition-colors ${
                      isActive
                        ? 'bg-blue-50 text-blue-700'
                        : 'text-gray-700 hover:bg-gray-50'
                    }`}
                  >
                    <Icon className="w-5 h-5 mr-3" />
                    <span className="font-medium">{item.name}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default OrgAdminSidebar; 